angular.module('picmonicng').factory('VotesResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/votes/:vote_id',
      { vote_id: '@vote_id' },
      {
        update: { method: 'PUT', isArray: false },
      }
    );
  },
]);
